"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCueGroup = void 0;
/**
 * A = control group
 *
 * B = test group
 */
const generateCueGroup = (userId) => {
    if (typeof userId !== 'string') {
        return undefined;
    }
    const firstCharacter = userId.charAt(0);
    if (['0', '1', '2', '3', '4', '5', '6', '7'].includes(firstCharacter)) {
        return 'a';
    }
    if (['8', '9', 'a', 'b', 'c', 'd', 'e', 'f'].includes(firstCharacter)) {
        return 'b';
    }
    return undefined;
};
exports.generateCueGroup = generateCueGroup;
